/**
 * Access control for routes that depend on legacy (before 10/2020) Shipping Operations
 * Requires a `data.capabilities` array to be set on the route
 *
 * @type {ngFactory}
 */
function TmrShippingOperationsLegacyAccessControl(
  TmrAppConfiguration,
  UserStorage
) {
  'ngInject'
  return state =>
    TmrAppConfiguration.get('version.shippingOperations') === 'legacy' &&
    UserStorage.hasAnyCapability(state.data.capabilities)
}

export const factory = [
  'TmrShippingOperationsLegacyAccessControl',
  TmrShippingOperationsLegacyAccessControl,
]
